<template>
    <BasicModalWindow ref="modal_element" @modalWindowClose='onModalWindowClose' :class="wizard_class" >
        <template #title>
            <ul v-if="slides_loaded" ref="slider_navigation" class="navigation">
                <li v-for="item, $index in slides.length - 1"
                    @click="onSetSlide($index)"
                    :key="item"
                    :class="{active : $index === slides_current}">
                      {{ item }}
                  </li>
            </ul>
        </template>
        <template #body>
            <div class="slider-container">
                <ul ref="slider_list" class="slider" :class="{'hidden': !slides_loaded}">
                    <!-- <li class="slide intro">
                        <h2>{{Language.say('wizard.welcome.header')}}</h2>
                        <h3>{{Language.say('wizard.welcome.text_1')}}</h3>
                        <p>{{Language.say('wizard.welcome.text_2')}} <strong>{{ Language.say('wizard.welcome.text_3') }}</strong></p>
                    </li> -->
                    <li class="slide layout-options">
                        <h2>{{Language.say('wizard.welcome.header')}}</h2>
                        <p>{{Language.say('wizard.welcome.text_1')}}</p>

                        <h3>{{ Language.say('wizard.theme_color.header') }}</h3>
                        <form>
                            <LayoutColorsList
                              :layout_controller="layout_controller"
                              :legend="false"
                            />
                        </form>
                    </li>
                    <li class="slide layout-options" >
                        <h2>{{ Language.say('wizard.theme_mode.header') }}</h2>
                        <form>
                            <LayoutViewMode
                              :layout_controller="layout_controller"
                            />
                        </form>
                    </li>
                    <li class="slide layout-options" v-if="state_indicator !== 'mobile'">
                        <h2>{{ Language.say('wizard.theme_orientation.header') }}</h2>
                        <form>
                            <LayoutOrientation
                              :layout_controller="layout_controller"
                            />
                        </form>
                    </li>
                    <li class="slide layout-options">
                        <h2>{{ Language.say('wizard.theme_font.header') }}</h2>
                        <form>
                            <LayoutFontSize
                              :layout_controller="layout_controller"
                            />
                        </form>
                    </li>

                    <li class="slide browser-notifications" data-wizard="browser-notifications" v-if="BrowserNotifications.supported">
                        <h2>{{ Language.say('wizard.notifications.header') }}</h2>
                            <BrowserNotifications
                            />
                    </li>

                    <li class="slide signature form" data-wizard="slide-signature">
                        <h2>{{ Language.say('wizard.identity.header') }}</h2>
                        <div class="control-group">
                            <div class="control">
                                <input id="identityName" type="text" v-model="identity_name" placeholder="O seu nome">
                            </div>
                        </div>
                        <div class="editor-group form">
                            <HTMLEditor
                              ref="editor_element"
                              inline_upload_type="single"
                              :image_size_limit="SAPOMailConfig.client.settings.signature.image_size_limit"
                              @modalOpen="onModalOpen"
                            />
                        </div>
                    </li>

                    <!-- NOVO SLIDE -->
                    <!-- <li class="slide overflow-auto"  v-if="AccountController.account.premium.allowed">
                      <div class="premium-logo top-right"></div>
                        <h2 class="quarter-bottom-space">Precisa de mais?</h2>
                        <h3>Conheça as vantagens do SAPO Mail Premium.</h3>

                        <h4 class="top-space">Acesso via programas de email:</h4>
                        <p>Configure o SAPO Mail num programa de email, como Outlook ou Thunderbird, no seu PC, telemóvel ou tablet.</p>

                        <h4>Mais espaço:</h4>
                        <p>Não queremos que falte espaço para as suas mensagens. Tem 65GB de armazenamento com o Premium.</p>

                        <h4>Sem publicidade:</h4>
                        <p>Uma experiência ainda mais simples, com remoção de todos os formatos de publicidade.</p>

                        <LinkButton
                          :link="SAPOMailConfig.server.external_links.premium"
                          :text="'Aderir ao Premium'"
                          class='main-action bottom-space'
                          target="_blank"
                        />

                    </li> -->

                    <!-- <li class="slide overflow-auto" v-if="AccountController.account.premium.allowed">
                        <h3>Conheça as vantagens do SAPO Mail Premium.</h3>

                        <h4>Proteção para contas inativas:</h4>
                        <p>No plano base, as contas abandonadas são hibernadas e limpas após algum tempo. As contas Premium ficam sempre ativas, mesmo quando não são acedidas durante longos períodos, sem entrarem em hibernação ou processos de limpeza.</p>

                        <h4>Reencaminhamento de mensagens:</h4>
                        <p>Com uma conta Premium, pode enviar automaticamente para outro endereço todas as mensagens recebidas.</p>

                        <LinkButton
                          :link="SAPOMailConfig.server.external_links.premium"
                          :text="'Aderir ao Premium'"
                          class='main-action bottom-space'
                          target="_blank"
                        />
                    </li> -->

                    <li class="slide closure" data-wizard="slide-closure">
                        <h2>{{ Language.say('wizard.closure.header') }}</h2>
                        <h3>{{ Language.say('wizard.closure.text_1') }} <a role="button" @click="onGoToDefinitions"><i class="fas fa-cog"></i> {{ Language.say('wizard.closure.link_1') }}</a></h3>
                        <p>{{ Language.say('wizard.closure.text_2') }} <strong>{{ Language.say('wizard.closure.text_3') }}</strong> {{ Language.say('wizard.closure.text_4') }}</p>
                    </li>
                </ul>
            </div>
        </template>

        <template #footer>
            <ActionButton v-show="slides_current === 0"
                @click="onAskLater()"
                class='outline ask-later'
                text="global.actions.ask_later"
                :disabled="wizard_controller.state.events['submitting'] === 'loading'"
            />

            <ActionButton v-show="slides_current !== 0 && slides_current !== slides.length - 1"
                @click="onActionRevertChanges()"
                class='outline revert'
                text="global.actions.cancel"
                :disabled="wizard_controller.state.events['submitting'] === 'loading'"
            />

            <ActionButton v-show="slides_current > 0 && slides_current !== slides.length - 1"
                @click="onPreviousSlide()"
                class='outline prev'
                text="global.actions.previous"
                :disabled="wizard_controller.state.events['submitting'] === 'loading'"
            />

            <ActionButton v-if="slides_current === slides.length - 1"
              @click="onClose()"
              class='main-action submit'
              text="global.actions.close"
            />

            <ActionButton v-else-if="slides_current !== slides.length - 2"
              @click="onNextSlide()"
              class='main-action next'
              :text="(slides_current === 0) ? 'global.actions.next' : 'global.actions.next'"
              :loading="wizard_controller.state.events['submitting'] === 'loading'"
            />

            <ActionButton v-else-if ="slides_current === slides.length - 2"
              @click="onFinished()"
              class='main-action submit'
              text="global.actions.finish"
              :loading="wizard_controller.state.events['submitting'] === 'loading'"
            />
        </template>
    </BasicModalWindow>

    <ConfirmModal v-if="modal_revert_visible"
        title="wizard.warning.header"
        text_revert="wizard.warning.revert_changes"
        text_confirm="wizard.warning.keep_changes"
        :show_cancel="false"
        :show_revert="true"
        @actionConfirm="onActionConfirmChanges()"
        @actionCancel="onActionCloseChanges()"
        @actionRevert="onActionRevertChanges()"
    >

      <template #modal_body>
        <p>
          {{Language.say('wizard.warning.ask_later_text')}}
        </p>
      </template>
    </ConfirmModal>
</template>

<script setup>
  import {ref, defineProps, reactive} from 'vue';
  import {onMounted}                 from 'vue';
  import LayoutSettingsController     from '@/js/Webmail/LayoutSettingsController';
  import LayoutColorsList             from '@/vue/Views/Settings/Layout/Partials/LayoutColorsList.vue';
  import LayoutViewMode               from '@/vue/Views/Settings/Layout/Partials/LayoutViewMode.vue';
  import LayoutOrientation            from '@/vue/Views/Settings/Layout/Partials/LayoutOrientation.vue';
  import LayoutFontSize               from '@/vue/Views/Settings/Layout/Partials/LayoutFontSize.vue';
  import BrowserNotifications         from '@/vue/Views/Settings/Notifications/Partials/BrowserNotifications.vue'
  import HTMLEditor                   from '@/vue/Elements/Tools/HTMLEditor/HTMLEditor.vue';
  import BasicModalWindow             from '@/vue/Layouts/Modals/BasicModalWindow.vue';
  import ActionButton                 from '@/vue/Elements/Buttons/ActionButton.vue';
  import ConfirmModal                 from '@/vue/Views/Webmail/Modals/ConfirmModal.vue';
  import Language                     from '@/js/Shared/Language/Language.js';
  import WizardController             from '@/js/Settings/Wizard/WizardController.js'
  import SAPOMailConfig               from '@/SAPOMailConfig';
  import IdentitiesController         from '@/js/Settings/Identities/IdentitiesController';
  import LinkButton                   from '@/vue/Elements/Buttons/LinkButton.vue';
  import AccountController            from '@/js/Webmail/AccountController';

  const props = defineProps({
    webmail_view : {},
  });


  const emit = defineEmits(['setupModalClose']);

  const modal_revert_visible    = ref(false);
  const layout_controller       = LayoutSettingsController;
  const wizard_controller       = reactive(new WizardController());
  const modal_element           = ref();
  const editor_element          = ref();
  const wizard_class            = ref('wizard');
  const state_indicator         = LayoutSettingsController.state_indicator;
  const identity_name           = ref();
  const slider_list             = ref();
  const slides_loaded           = ref(false);
  const slides_current          = ref(0);
  const slides_previous         = ref(-1);
  const slides                  = ref([]);
  const finished                = ref(false);
  const started                 = ref(false);

  onMounted(() => {
    setSlides();
    setSlidesTranslate();
    setSlidesLoaded(true);
    wizard_controller.saveCurrentConfiguration();
    setIdentity();
  })

  const onModalWindowClose = () => {
    if (started.value === true && finished.value === false) {
      setModalRevertVisibility(true);
      return;
    }

    props.webmail_view.closeModal('SETTINGS_WIZARD');
    emit('setupModalClose');
  }

  const onModalOpen = (expand) => {
    modal_element.value.expand(expand);
  }

  const onClose = () => {
    props.webmail_view.closeModal('SETTINGS_WIZARD');
    emit('setupModalClose');
  }

  const onActionRevertChanges = async () => {
    setModalRevertVisibility(false);
    await wizard_controller.revert();
    props.webmail_view.closeModal('SETTINGS_WIZARD');
    wizard_controller.revertConfiguration();
    emit('setupModalClose');
  }

  const onFinished = async () => {
    await wizard_controller.finished(identity_name.value, editor_element.value.editor.getContents());
    setCurrentSlide(slides_current.value + 1);
    setSlidesTranslate();
    setWizardClass();
    setFinished(true);
  }

  const onAskLater = async () => {
    await wizard_controller.askLater();
    props.webmail_view.closeModal('SETTINGS_WIZARD');
    emit('setupModalClose');
  }

  const onNextSlide = () => {
    setCurrentSlide(slides_current.value + 1);
    setSlidesTranslate();
    setWizardClass();
    setStarted(true);
  }

  const onPreviousSlide = () => {
    setCurrentSlide(slides_current.value - 1);
    setSlidesTranslate();
    setWizardClass();
  }

  const onSetSlide = (index) => {
    setCurrentSlide(index);
    setSlidesTranslate();
    setWizardClass();
  }

  const onGoToDefinitions = () => {
    props.webmail_view.routeTo('/settings');
    props.webmail_view.closeModal('SETTINGS_WIZARD');
  }

  const onActionCloseChanges = () => {
    setModalRevertVisibility(false);
  }

  const onActionConfirmChanges = () => {
    setModalRevertVisibility(false);
    props.webmail_view.closeModal('SETTINGS_WIZARD');
    emit('setupModalClose');
  }

  const setFinished = (value) => {
    finished.value = value;
  }

  const setStarted = (value) => {
    started.value = value;
  }

  const setSlidesTranslate = () => {
    if (slider_list.value)  {
      slider_list.value.style.transform = `translateX(-${slides_current.value * 100}%)`;
    }
    // slides.value.forEach((slide, index) => {
    //   let translate_value = (index - slides_current.value ) * 100;

    //   if (translate_value >= 100) {
    //     translate_value = 100;
    //   }

    //   else if (translate_value <= -100) {
    //     translate_value = -100;
    //   }

    //   slide.style.transform = `translateX(${translate_value}%)`;

    //   if (index === slides_current.value || index === slides_previous.value) {
    //     slide.classList.add('animated');
    //     return;
    //   }

    //   slide.classList.remove('animated');

    // })
  }

  const setModalRevertVisibility = (value) => {
    modal_revert_visible.value = value;
  }

  const setIdentity = () => {
    let identity        = IdentitiesController.identities.getDefault();
    identity_name.value = identity.name;
    editor_element.value.editor.setContents(identity.signature_html);
  }

  const setSlides = () => {
    slides.value = document.querySelectorAll('.slide');
  }

  const setSlidesLoaded = (value) => {
    slides_loaded.value = value;
  }

  const setCurrentSlide = (value) => {
    slides_previous.value = slides_current.value;
    slides_current.value  = value;
  }

  const setWizardClass = () => {
    let wizard         = slides.value[slides_current.value].getAttribute('data-wizard');
    wizard_class.value = 'wizard';

    if (wizard) {
      wizard_class.value += ' ' + wizard;
    }
  }

</script>
